import React, { useState } from "react";
import {
  Box,
  Button,
  Autocomplete,
  FormControl,
  TextField,
  CardContent,
  Backdrop,
  CircularProgress,
  Checkbox,
  ListItemText,
  Chip,
} from "@mui/material";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { PageBar } from "../../CommonComponents";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import axios from "axios";
import { toast } from "react-toastify";
import Cookies from "js-cookie";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { format } from "date-fns";

const Index = () => {
  const [stores, setStores] = useState([]);
  const [selectedStoreCode, setSelectedStoreCode] = useState("");
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [capacity, setCapacity] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedStoreType, setSelectedStoreType] = useState([]);
  const navigate = useNavigate();
  const columns = [
    { field: "loc", headerName: "Store", width: 180 },
    { field: "slot_date", headerName: "Slot Date", width: 180 },
    { field: "slot_start", headerName: "Window", width: 180 },
    { field: "demand", headerName: "Demand", width: 180 },
    { field: "lm_by", headerName: "LM By", width: 180 },
    { field: "lm_cap", headerName: "LM Capacity", width: 180 },
    { field: "picker_cap", headerName: "Picker Capacity", width: 180 },
    { field: "final_cap", headerName: "Final Capacity", width: 180 },
  ];
  const storeTypeOptions = [
    { label: "All", value: "all" },
    { label: "SM", value: "SM" },
    { label: "HM", value: "HM" },
    { label: "DS", value: "DS" },
  ];
  const styles = `
  .highlight-cell {
    background-color: #FFB09C !important;
  }
`;

  const handleGetStores = async () => {
    try {
      setLoading(true);
      const response = await axios.get(
        "https://45da4uqkcc.execute-api.ap-south-1.amazonaws.com/default/get_stores",
        {
          params: {
            store_type:
              selectedStoreType.includes("all") ||
              selectedStoreType.length === 0
                ? "all"
                : selectedStoreType.join(","),
          },
          headers: {
            Authorization: Cookies.get("ssp_sso_token"),
            "content-type": "application/json",
          },
        }
      );
      if (response?.data?.success) {
        setStores(response?.data?.data);
        setLoading(false);
      } else {
        toast.error("Something went wrong, please try again later!");
        setLoading(false);
        return;
      }
    } catch (error) {
      console.log(error);
      toast.error("Something went wrong, please try again later!");
      setLoading(false);
    }
  };

  const handleGetCapacity = async () => {
    try {
      const response = await axios.get(
        "https://45da4uqkcc.execute-api.ap-south-1.amazonaws.com/default/get_capacity",
        {
          params: {
            store_code: selectedStoreCode,
            date: format(new Date(selectedDate), "yyyy-MM-dd"),
          },
          headers: {
            Authorization: Cookies.get("ssp_sso_token"),
            "content-type": "application/json",
          },
        }
      );
      if (response?.data?.success) {
        const updatedData = response.data.data.map((item, index) => ({
          ...item,
          id: index + 1,
        }));
        setCapacity(updatedData);
      } else {
        toast.error("Something went wrong, please try again later!", {
          position: "top-right",
        });
        return;
      }
    } catch (error) {
      console.log(error);
      toast.error("Something went wrong, please try again later!", {
        position: "top-right",
      });
    }
  };

  const filterOptions = (options, { inputValue }) => {
    const input = inputValue.toLowerCase();
    return options.filter(
      (option) =>
        option.store_name.toLowerCase().includes(input) ||
        option.store_code.toString().includes(input)
    );
  };
  const handleChange = (event, newValue) => {
    const selectedValues = newValue.map((option) => option.value);
    const allIndividualOptions = storeTypeOptions
      .filter((option) => option.value !== "all")
      .map((option) => option.value);

    if (selectedValues.includes("all") && !selectedStoreType.includes("all")) {
      setSelectedStoreType(["all"]);
      return;
    }
    if (selectedStoreType.includes("all") && !selectedValues.includes("all")) {
      setSelectedStoreType([]);
      return;
    }
    if (allIndividualOptions.every((value) => selectedValues.includes(value))) {
      setSelectedStoreType(["all"]);
    } else {
      setSelectedStoreType(selectedValues.filter((value) => value !== "all"));
    }
  };

  useEffect(() => {
    handleGetStores();
  }, [selectedStoreType]);
  useEffect(() => {
    if (selectedStoreCode !== "") {
      handleGetCapacity();
    }
  }, [selectedStoreCode, selectedDate]);

  return (
    <>
      {loading ? (
        <Backdrop
          sx={{
            zIndex: (theme) => theme.zIndex.drawer + 1,
            color: "#fff",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
          }}
          open={loading}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      ) : null}
      <Box>
        <PageBar text="SmartCap" />
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            paddingRight: "2.5rem",
            marginTop: "1rem",
          }}
        >
          <Button
            variant="contained"
            style={{ backgroundColor: "#6558F5", color: "white" }}
            onClick={() => navigate("/upload")}
          >
            Bulk Upload
          </Button>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            paddingRight: "2.5rem",
            marginTop: "2rem",
            gap: "1rem",
          }}
        >
          <FormControl sx={{ width: 200, maxWidth: 200 }}>
            <Autocomplete
              multiple
              disablePortal
              id="store-type-selector"
              options={storeTypeOptions}
              getOptionLabel={(option) => option.label}
              value={storeTypeOptions.filter((option) =>
                selectedStoreType.includes("all")
                  ? true
                  : selectedStoreType.includes(option.value)
              )}
              onChange={handleChange}
              disableCloseOnSelect
              sx={{
                "& .MuiAutocomplete-inputRoot": {
                  height: "3.5rem",
                  padding: "4px 8px",
                  "& .MuiAutocomplete-input": {
                    minHeight: "24px",
                  },
                },
              }}
              PaperProps={{
                sx: {
                  // maxHeight: 200,
                  overflowY: "auto",
                  borderRadius: 2,
                  boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                  height: "3.5rem",
                },
              }}
              renderOption={(props, option, { selected }) => (
                <li {...props}>
                  <Checkbox
                    size="small"
                    sx={{ marginRight: 1, padding: 0.5 }}
                    checked={selectedStoreType.includes("all") || selected}
                  />
                  <ListItemText
                    primary={option.label}
                    primaryTypographyProps={{ variant: "body2" }}
                  />
                </li>
              )}
              renderTags={(value, getTagProps) =>
                selectedStoreType.includes("all")
                  ? [
                      <Chip
                        key="all"
                        label="All"
                        deleteIcon={null}
                        {...getTagProps({ index: 0 })}
                        onDelete={undefined}
                        size="small"
                        sx={{
                          maxWidth: 80,
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          margin: "2px",
                          height: 24,
                        }}
                      />,
                    ]
                  : value.map((option, index) => (
                      <Chip
                        key={option.value}
                        label={option.label}
                        deleteIcon={null}
                        {...getTagProps({ index })}
                        onDelete={undefined}
                        size="small"
                        sx={{
                          maxWidth: 80,
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          margin: "2px",
                          height: 24,
                        }}
                      />
                    ))
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Store Type"
                  variant="outlined"
                  sx={{
                    "& .MuiInputLabel-root": { fontSize: "0.9rem" },
                    "& .MuiOutlinedInput-root": {
                      fontSize: "0.9rem",
                      "& fieldset": { borderColor: "grey.400" },
                      "&:hover fieldset": { borderColor: "primary.main" },
                    },
                  }}
                />
              )}
            />
          </FormControl>
          <FormControl style={{ width: 300 }}>
            <Autocomplete
              disablePortal
              id="combo-box-demo"
              name="store_id"
              options={stores}
              getOptionLabel={(option) => option.store_name}
              filterOptions={filterOptions}
              onChange={(event, newValue) => {
                setSelectedStoreCode(newValue ? newValue.store_code : "");
              }}
              value={
                stores.find(
                  (store) => store.store_code === selectedStoreCode
                ) || null
              }
              renderInput={(params) => (
                <TextField {...params} name="dc_store" label="Select Stores" />
              )}
            />
          </FormControl>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DatePicker
              fullWidth
              autoComplete="username"
              type="text"
              label="Select Date"
              value={selectedDate}
              onChange={(newValue) => {
                setSelectedDate(newValue);
              }}
              renderInput={(params) => <TextField {...params} />}
            />
          </LocalizationProvider>
        </div>
        <CardContent
          sx={{
            backgroundColor: "#FFFFFF",
            borderBottomRightRadius: "5px",
            borderBottomLeftRadius: "5px",
            marginTop: "1rem",
          }}
        >
          <Box
            sx={{
              display: { lg: "flex" },
              height: 500,
              width: "100%",
            }}
          >
            <style>{styles}</style>
            <DataGrid
              disableColumnMenu={true}
              rowHeight={80}
              showCellRightBorder={true}
              sx={{
                ".MuiDataGrid-columnHeaderTitle": {
                  fontWeight: "bold !important",
                },
                ".MuiDataGrid-cell": {
                  fontSize: "0.8rem",
                },
                overflowX: "scroll",
              }}
              rows={capacity}
              columns={columns}
              initialState={{
                pagination: {
                  paginationModel: {
                    pageSize: 10,
                  },
                },
              }}
              headerClassName="header-center"
              rowsPerPageOptions={[10]}
              pageSize={10}
              getRowId={(row) => row.id}
              components={{
                Toolbar: GridToolbar,
              }}
              componentsProps={{
                Toolbar: {
                  showQuickFilter: true,
                  quickFilterProps: { debounceMs: 500 },
                },
              }}
              getCellClassName={(params) => {
                if (
                  params.field === "picker_cap" &&
                  params.row.picker_cap !== null
                ) {
                  const pickerCap = Number(params.row.picker_cap);
                  const Demand = Number(params.row.demand);
                  const shouldHighlight =
                    pickerCap != null && Demand != null && Demand > pickerCap;
                  return shouldHighlight ? "highlight-cell" : "";
                }
                if (params.field === "lm_cap" && params.row.lm_cap !== null) {
                  const lmCap = Number(params.row.lm_cap);
                  const demand = Number(params.row.demand);
                  const shouldHighlightLm =
                    lmCap != null && demand != null && demand > lmCap;
                  return shouldHighlightLm ? "highlight-cell" : "";
                }
                return "";
              }}
            />
          </Box>
        </CardContent>
      </Box>
    </>
  );
};

export default Index;
